import { getInitialToken } from './utils';
import type {
  UserState,
  AuthenticationAction,
  SavedUserPreferences,
  UpdatePreferencesAction
} from './types';

const initialState: UserState = {
  status: getInitialToken() ? 'LOADING' : 'NOT_AUTHENTICATED',
  currentUser: null,
  userType: 'trial',
  emailNotConfirmed: false
};

const initialPreferences: SavedUserPreferences = {
  ebattles_display: false,
  overround_displayed: null,
  odds_format: 'decimal',
  theme: 'auto',
  competitors_display: true,
  competitors_display_match_winner_2_way: true,
  competitors_display_prematch_during_live: true,
  competitors_selected: ['bet365', 'ggbet', 'pandaodds', 'pinnacle']
};

function reducer(
  value: UserState,
  action: AuthenticationAction | UpdatePreferencesAction
): UserState {
  switch (action.type) {
    case 'AUTHENTICATION_REQUEST':
      return {
        ...value,
        status: 'LOADING'
      };

    case 'AUTHENTICATION_SUCCESS': {
      const { user, userType } = action.payload;
      return {
        ...value,
        status: 'SUCCEED',
        currentUser: user,
        userType,
        emailNotConfirmed: false
      };
    }

    case 'AUTHENTICATION_FAIL':
      return {
        ...value,
        status: 'FAILED',
        currentUser: null
      };

    case 'RESET_AUTHENTICATION_ERROR':
      return {
        ...value,
        status: 'NOT_AUTHENTICATED',
        currentUser: null
      };

    case 'LOGOUT':
      return {
        ...value,
        status: 'NOT_AUTHENTICATED',
        currentUser: null,
        emailNotConfirmed: false
      };

    case 'EMAIL_NOT_CONFIRMED_ERROR': {
      return {
        ...value,
        status: 'NOT_AUTHENTICATED',
        emailNotConfirmed: true
      };
    }

    case 'UPDATE_PREFERENCES': {
      const user = value.currentUser
        ? {
            ...value.currentUser,
            preferences: {
              ...value.currentUser?.preferences,
              ...action.payload
            }
          }
        : null;

      return {
        ...value,
        currentUser: user
      };
    }

    default:
      return value;
  }
}

export { initialState, initialPreferences, reducer };
